import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import EmployeeProfile from './Components/Employeeprofile';
import LeavePortal from './Components/Leaveportal';
import LeaveManagement from './Components/Leavemanagement';
import EmployeeProductivity from './Components/Employeeproductivity';
import Announcement from './Components/Announcements';
import Policies from './Components/Policies';
// import Clientcommunication from './Components/Clientcommunication';
import Ticketsystem from './Components/Ticketsystem';
import TaskUpdateForm from './Components/Taskupdate';
import LoginPage from './Components/Login';
import NewPage from './Components/Crm';
import HrDashboard from './Components/Hr_dashboard';
import ProjectManagerDashboard from './Components/Projectmanager_dashboard';
import TaskAssignment from './Components/Taskassignment';
import TaskAssignmentForm from './Components/Taskassignmentretrival';
// import FormPage from './Components/Form';  // Correctly importing FormPage
import SalesPerformancePage from './Components/Salesperformance';
import FollowUpPage from './Components/Followup';
import EmployeeDashboard from './Components/Employee_dashboard';
import SalesForChief from './Components/Salesforchief';
import EmployeeProductivityManager from './Components/Employeeproductivityformanager';
import ExpenseTracker from './Components/Expensetracking';
import ExpenseTrackerChief from './Components/Expensetrackingforchief';
import ExpenseCategory from './Components/Adminpageretrival';
import CombinedPage from './Components/Adminfrontend';
import ExpenseApprovalPage from './Components/Approvalretrival';
import Approvalmainpage from './Components/Approvalmainpage';
import Tracking from './Components/locationtracking';
import Location from './Components/locationtracking2';
import ExpenseEntryPage from './Components/Expenseentry';
// import MarketingDashboard from './Components/Marketing_dashboard';
import Revenue from './Components/Revenue';
import Sales from './Components/Sales.js';
import MOUProcess from './Components/MOUProcess.js';
import UpcomingPayments from './Components/UpcomingPayments.js';
import PaymentLink from './Components/PaymentLink.js';
import Centralisation from './Components/Centralisation.js';
import UpcomingPaymentDates from "./Components/UpcomingPaymentDates";
import MouOrderForm from './Components/MouOrderForm.js';
import Reports from './Components/Reports.js';
import SigninPage from './Components/SigninPage.js';
import FormLayout from './Components/FormLayout.js';
import MarketingDashboardlayout from './Components/MarketingDashboardLayout.js';
import HrDashboardLayout from './Components/HrDashboardLayout.js';
import ProjectManagerLayout from './Components/ProjectManagerLayout.js';
import ProjectLeave from './Components/ProjectLeave.js';
import Mobile from './Components/Mobile.js';
import SalesperformanceDashboard from './Components/SalesperformanceDashboard.js';
import SalesPerformanceManager from './Components/SalesPerformanceManger.js';
import FollowUpManager from './Components/Followupmanager.js';
// import SalesReport from './Components/SalesReport.js';
// import Aside from './Components/FormAside.js';


// import AdminPage from './Components/Admin';



function App() {
  // const [isMobile, setIsMobile] = useState(window.innerWidth<768);

// useEffect(()=>{
//   const handleResize =()=>{
//     // setIsMobile(window.innerWidth<768);
//   };
//   window.addEventListener("resize",handleResize);
//   return ()=> window.removeEventListener("resize",handleResize);
// },[]) 
  return (
    

    <Router basename="/Mark"> {/* Use basename for the subdirectory */}
      <div className="App">
        {/* Define all routes here */}

        {/* <Aside className="asideBar" /> */}

        <div >
          <Routes>
            <Route path="/" element={<LoginPage />} /> {/* Render LoginPage at the root */}
            <Route path="/NewPage" element={<NewPage />} />
            <Route path="/Leaveportal" element={<LeavePortal />} />
            <Route path="/Taskupdate" element={<TaskUpdateForm />} />
            <Route path="/Employeeprofile" element={<EmployeeProfile />} />
            <Route path="/Leavemanagement" element={<LeaveManagement />} />
            <Route path="/Employeeproductivity" element={<EmployeeProductivity />} />
            <Route path="/Announcements" element={<Announcement />} />
            <Route path="/Policies" element={<Policies />} />
            <Route path="/MouOrderForm" element={<MouOrderForm />} />

            {/* <Route path="/Clientcommunication" element={<Clientcommunication />} /> */}
            <Route path="/Ticketsystem" element={<Ticketsystem />} />
            {/* <Route path="/HrDashboard" element={<HrDashboard />} /> */}
            <Route path='/HrDashboard' element={<HrDashboardLayout />} />
            {/* <Route path="/ProjectManagerDashboard" element={<ProjectManagerDashboard />} /> */}
            <Route path='/ProjectManagerDashboard' element={<ProjectManagerLayout />} />
            <Route path="/ProjectManagerDashboard/Leaveportal" element={<ProjectLeave/>}/>
            <Route path="/TaskAssignment" element={<TaskAssignment />} />
            <Route path="/Taskassignmentretrival" element={<TaskAssignmentForm />} />
            {/* <Route path="/Form" element={<FormPage />} />{ /* Route for FormPage   */}
            <Route path="/Form" element={<FormLayout />} />
             {/* <Route path='/Report' element={<SalesReport />}/> */}
            <Route path="/Salesperformance" element={<SalesperformanceDashboard />} />
            <Route path="/Employee_dashboard" element={<EmployeeDashboard />} />
            <Route path="/Salesforchief" element={<SalesForChief />} />
            <Route path="Expensetrackingforchief" element={<ExpenseTrackerChief />} />
            <Route path="/Employeeproductivityformanager" element={<EmployeeProductivityManager />} />
            <Route path="/Expensetracking" element={<ExpenseTracker />} />
            {/* <Route path="/Admin" element={<AdminPage />} /> */}
            <Route path="/Approvalmainpage/*" element={<Approvalmainpage />} />
            <Route path="/Approvalretrival" element={<ExpenseApprovalPage />} />
            <Route path="/Adminpageretrival" element={<ExpenseCategory />} />
            <Route path="/Adminfrontend" element={<CombinedPage />} />
            <Route path="/Followup" element={<FollowUpPage />} />
            <Route path="/locationtracking" element={<Tracking />} />
            <Route path="/locationtracking2" element={<Location />} />
            {/* <Route path="/Marketing_dashboard" element={<MarketingDashboard />} /> */}
            <Route path="/Marketing_dashboard" element={<MarketingDashboardlayout />} />

            <Route path="/SalesPerformanceManager" element={<SalesPerformanceManager />} />
            <Route path="/FollowUpManager" element={<FollowUpManager />} />

            <Route path="/Expenseentery" element={<ExpenseEntryPage />} />
            <Route path="/Revenue" element={<Revenue />} />
            <Route path="/Sales" element={<Sales />} />
            <Route path="/MOUProcess" element={<MOUProcess />} />

            <Route path="/UpcomingPayments" element={<UpcomingPayments />} />
            <Route path="/PaymentLink" element={<PaymentLink />} />
            <Route path="/signpage/:id" element={<SigninPage />} />
            <Route path="/Centralization" element={<Centralisation />} />
            <Route path="/Centralisation" element={<Centralisation />} />
            <Route path="/Reports" element={<Reports />} />
            <Route
              path="/UpcomingPaymentDates"
              element={<UpcomingPaymentDates />}
            />
          </Routes>
        </div>

      </div>
    </Router>
  );
}

export default App;